export default __webpack_public_path__ + "static/media/death.a51d6153.svg";